// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1sbN0","cardMid":"style_cardMid__44EF-","autoFit":"style_autoFit__l4M2W","donutGuide":"style_donutGuide__2EUvd","g2Legend":"style_g2Legend__3i92U"};